import authRequest from '../authRequest';

export default async function uploadAudioFile(sessionUuid, audioFile) {
  if (!sessionUuid || !audioFile) {
    throw new Error('sessionUuid and audioFile are required');
  }
  const formData = new FormData();
  formData.append('audio', audioFile);

  return authRequest(`/sessions/${sessionUuid}/upload_audio_file`, {
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
} 